<div class="flex-apart">
  <h3>Guest Information</h3>
  @if (canUpdate) {
    <button mat-icon-button (click)="enableUserInfoEdit()" aria-label="Edit guest information">
      <span class="material-icons">edit</span>
    </button>
  }
</div>

<section>
  <mat-form-field appearance="fill">
    <mat-label>Last Name</mat-label>
    <input
      matInput
      [(ngModel)]="guest.lastName"
      name="lastName"
      required
      [disabled]="!canEdit && !isNewAccount"
      [readonly]="!canEdit && !isNewAccount"
      autocomplete="off"
      autocorrect="off"
    />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Rest of Name</mat-label>
    <input
      matInput
      [(ngModel)]="guest.firstName"
      name="firstName"
      #firstName="ngModel"
      required
      [disabled]="!canEdit && !isNewAccount"
      [readonly]="!canEdit && !isNewAccount"
      autocomplete="off"
      autocorrect="off"
    />
  </mat-form-field>
</section>

<section>
  <mat-form-field appearance="fill">
    <mat-label>Preferred Name</mat-label>
    <input matInput [(ngModel)]="guest.preferredName" name="preferredName" [disabled]="!isNewAccount" [readonly]="!isNewAccount" autocomplete="off" autocorrect="off" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Birthdate</mat-label>
    <input
      matInput
      [matDatepicker]="birthdatePicker"
      [(ngModel)]="guest.birthdate"
      name="birthdate"
      required
      [disabled]="!canEdit"
      [readonly]="!canEdit"
      autocomplete="off"
      autocorrect="off"
    />
    <mat-datepicker-toggle matIconSuffix [for]="birthdatePicker"></mat-datepicker-toggle>
    <mat-datepicker #birthdatePicker startView="multi-year"></mat-datepicker>
  </mat-form-field>
</section>

<section>
  <mat-form-field appearance="fill">
    <mat-label>Gender</mat-label>
    <mat-select [(ngModel)]="guest.gender" name="gender" [disabled]="!isNewAccount" required>
      <mat-option value="M">Male</mat-option>
      <mat-option value="F">Female</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>I-Number</mat-label>
    <input matInput [(ngModel)]="guest.iNumber" name="iNumber" readonly disabled autocomplete="off" autocorrect="off" />
  </mat-form-field>
</section>

<section>
  <mat-form-field appearance="fill">
    <mat-label>Personal Email</mat-label>
    <input matInput [(ngModel)]="guest.email" name="email" required [disabled]="!canEditUserInfo" autocomplete="off" autocorrect="off" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Phone Number</mat-label>
    <input matInput [(ngModel)]="guest.phone" name="phone" required [disabled]="!canEditUserInfo" autocomplete="off" autocorrect="off" />
  </mat-form-field>
</section>

<mat-form-field appearance="fill" class="section-margin">
  <mat-label>Home Address</mat-label>
  <input matInput [(ngModel)]="guest.address" name="address" [disabled]="!canEditUserInfo" required autocomplete="off" autocorrect="off" />
</mat-form-field>
<section>
  <mat-form-field appearance="fill">
    <mat-label>City</mat-label>
    <input matInput [(ngModel)]="guest.city" name="city" [disabled]="!canEditUserInfo" required autocomplete="off" autocorrect="off" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>State</mat-label>
    <mat-select [(ngModel)]="guest.state" name="state" [disabled]="!canEditUserInfo" required>
      <mat-option value="AL">Alabama</mat-option>
      <mat-option value="AK">Alaska</mat-option>
      <mat-option value="AZ">Arizona</mat-option>
      <mat-option value="AR">Arkansas</mat-option>
      <mat-option value="CA">California</mat-option>
      <mat-option value="CO">Colorado</mat-option>
      <mat-option value="CT">Connecticut</mat-option>
      <mat-option value="DE">Delaware</mat-option>
      <mat-option value="DC">District Of Columbia</mat-option>
      <mat-option value="FL">Florida</mat-option>
      <mat-option value="GA">Georgia</mat-option>
      <mat-option value="HI">Hawaii</mat-option>
      <mat-option value="ID">Idaho</mat-option>
      <mat-option value="IL">Illinois</mat-option>
      <mat-option value="IN">Indiana</mat-option>
      <mat-option value="IA">Iowa</mat-option>
      <mat-option value="KS">Kansas</mat-option>
      <mat-option value="KY">Kentucky</mat-option>
      <mat-option value="LA">Louisiana</mat-option>
      <mat-option value="ME">Maine</mat-option>
      <mat-option value="MD">Maryland</mat-option>
      <mat-option value="MA">Massachusetts</mat-option>
      <mat-option value="MI">Michigan</mat-option>
      <mat-option value="MN">Minnesota</mat-option>
      <mat-option value="MS">Mississippi</mat-option>
      <mat-option value="MO">Missouri</mat-option>
      <mat-option value="MT">Montana</mat-option>
      <mat-option value="NE">Nebraska</mat-option>
      <mat-option value="NV">Nevada</mat-option>
      <mat-option value="NH">New Hampshire</mat-option>
      <mat-option value="NJ">New Jersey</mat-option>
      <mat-option value="NM">New Mexico</mat-option>
      <mat-option value="NY">New York</mat-option>
      <mat-option value="NC">North Carolina</mat-option>
      <mat-option value="ND">North Dakota</mat-option>
      <mat-option value="OH">Ohio</mat-option>
      <mat-option value="OK">Oklahoma</mat-option>
      <mat-option value="OR">Oregon</mat-option>
      <mat-option value="PA">Pennsylvania</mat-option>
      <mat-option value="RI">Rhode Island</mat-option>
      <mat-option value="SC">South Carolina</mat-option>
      <mat-option value="SD">South Dakota</mat-option>
      <mat-option value="TN">Tennessee</mat-option>
      <mat-option value="TX">Texas</mat-option>
      <mat-option value="UT">Utah</mat-option>
      <mat-option value="VT">Vermont</mat-option>
      <mat-option value="VA">Virginia</mat-option>
      <mat-option value="WA">Washington</mat-option>
      <mat-option value="WV">West Virginia</mat-option>
      <mat-option value="WI">Wisconsin</mat-option>
      <mat-option value="WY">Wyoming</mat-option>
    </mat-select>
  </mat-form-field>
</section>

<mat-form-field appearance="fill">
  <mat-label>Postal Code</mat-label>
  <input matInput [(ngModel)]="guest.postalCode" name="postalCode" required [disabled]="!canEditUserInfo" autocomplete="off" autocorrect="off" />
</mat-form-field>

@if (canUpdate) {
  <div class="action-buttons">
    @if (canEditUserInfo) {
      <button mat-raised-button color="primary" (click)="saveGuestInfo()">Update user info</button>
    }
    @if (canEditUserInfo) {
      <button mat-raised-button color="warn" (click)="disableUserInfoEdit()">Cancel</button>
    }
  </div>
  @if (guestInfoLoading) {
    <app-loading message="saving user information, please wait...."></app-loading>
  }
}
